import { createBrowserRouter } from 'react-router-dom'
import Home from '../pages/Home/Home'
import NotFoundPage from '../pages/NotFound/NotFoundPage'
import Report from '../pages/Report/Report'

export const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <Home />,
    },
    {
      path: '/report/:token',
      element: <Report />,
    },
    {
      path: '*',
      element: <NotFoundPage />,
    },
  ],
  // IS_DEV ? undefined : { basename: '/' },
)
